import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AssetDto, DisplayGuestDto, DisplayUser } from '@nusign/picflow-backend-types';
import { map } from 'rxjs';
import { StateService } from '../../../services/state.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { AssetPageDataService } from '../../services/asset-page-data.service';

@Component({
  selector: 'app-favorite-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContextMenuComponent, AsyncPipe],
  templateUrl: './favorite-button.component.html',
  styleUrl: './favorite-button.component.scss',
})
export class FavoriteButtonComponent {
  private assetPageDataService = inject(AssetPageDataService);
  private state = inject(StateService);
  disabled = input.required<boolean>();
  asset = input.required<AssetDto>();

  getFavoritedUsers() {
    return this.assetPageDataService.getAssetLikeUsers(this.asset().id).pipe(
      map(users => {
        const currentUserId = this.state.user?.id || this.state.guest?.id;
        return users.map(user => {
          const isCurrentUser = user.id === currentUserId;
          const name = this.getUserName(user);
          return name + (isCurrentUser ? ' (You)' : '');
        });
      })
    );
  }

  private getUserName(
    user: (DisplayUser | DisplayGuestDto) & {
      id: string;
    }
  ) {
    if ('name' in user) return user.name;
    if ('first_name' in user) {
      return user.first_name + (user.last_name ? ' ' + user.last_name : '');
    }
  }
}
